import React, { memo } from "react";
import type { BookUIProps } from "./interfaces";

const Book = ({
  leftPart,
  overlineText,
  overlineTextColor,
  title,
  subtitle,
  footer,
  rightPart,
  className = "",
  children,
}: BookUIProps) => {
  return (
    <div className={`${className} pr df aic`}>
      {leftPart}
      <div className={"ml12 f1 df fdc jcc"}>
        {!!overlineText && (
          <span
            className={"t_overline c_primary df"}
            style={{ color: overlineTextColor }}
          >
            &quot;<span className={"ell"}>{overlineText}</span>&quot;
          </span>
        )}
        <strong className={"t_title_s c_l ell mt2"}>{title}</strong>
        {typeof subtitle === "string" ? (
          <span className={"t_body_s c_m ell mt2"}>{subtitle}</span>
        ) : (
          subtitle
        )}
        {footer}
      </div>
      {rightPart}
      {children}
    </div>
  );
};

export default memo(Book);
